import { css } from "styled-components";
export const brandGradient = css `
      linear-gradient(90.81deg, #27367B -0.48%, #28377C 57.18%, #1445B8 88.83%,
      #27367B 97.96%)
`;
export default brandGradient;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJhbmRHcmFkaWVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9taXhpbnMvYnJhbmRHcmFkaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsR0FBRyxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFFeEMsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUFHLEdBQUcsQ0FBQTs7O0NBRy9CLENBQUM7QUFFRixlQUFlLGFBQWEsQ0FBQyJ9